import React, { Component } from 'react'

import { Checkbox } from 'components/Input/Checkbox'

import s from './CheckboxRow.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default class CheckboxRow extends Component {
  render() {
    const { children, style, ...otherProps } = this.props
    return (
      <div
        className={cn(s.row, sLay['layout-row'], sLay['layout-align-center-center'])}
        style={style}
      >
        <Checkbox {...otherProps} />
        <div className={sLay.flex}>{children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/CheckboxRow/CheckboxRow.jsx